import axios from 'axios';
import { config } from '/app/config';

const sdk = axios.create({
  baseURL: config.functions.baseURL,
  timeout: 50000,
});

export const randomImages = params => sdk.get('/random-images', { params });
